import { useMutation } from "@apollo/client";
import { Alert, Button, Grid, Snackbar, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { CallFlowVersion } from "../../../../types/api";
import { CREATE_CALL_SCHEDULE } from "../../queries";
import { CreateScheduleResponse, ScheduleFormInputs } from "./types";

export const AddScheduleForm = () => {
  const { register, handleSubmit } = useForm<ScheduleFormInputs>();
  const [showError, setShowError] = useState<boolean>(false);

  const navigate = useNavigate();

  const [createCallSchedule, { error, loading }] = useMutation<
    CreateScheduleResponse,
    ScheduleFormInputs
  >(CREATE_CALL_SCHEDULE);

  const { id } = useParams();
  const userId: number = parseInt(id ?? "") || 0;

  const onSubmit: SubmitHandler<ScheduleFormInputs> = async (response) => {
    try {
      if (response.cronExpression === "* * * * *") {
        throw new Error();
      }
      await createCallSchedule({
        variables: {
          cronExpression: response.cronExpression,
          accountId: userId,
          callFlowVersion: CallFlowVersion.V2,
        },
      });
      navigate("/refresh");
    } catch (error) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-console
      console.error("Failed to create call schedule");
      setShowError(true);
    }
  };

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ gap: 2 }}
        >
          <TextField
            {...register("cronExpression")}
            margin="dense"
            label="CRON Expression"
            variant="standard"
            required={true}
          />

          <Button type="submit" disabled={loading} className="button">
            Create New Schedule
          </Button>
        </Grid>
      </form>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showError}
        onClose={() => setShowError(false)}
      >
        <Alert onClose={() => setShowError(false)} severity="error">
          Failed to create call schedule.
        </Alert>
      </Snackbar>
    </>
  );
};
